import { announceStorage } from "./storageEvents";
const TOKEN_KEY = "pp_token";
const NAME_KEY = "pp_name";

export function saveToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
  announceStorage();
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NAME_KEY);
  announceStorage();
}

export function saveName(name: string) {
  localStorage.setItem(NAME_KEY, name);
  announceStorage();
}

export function getName(): string | null {
  return localStorage.getItem(NAME_KEY);
}

export function authHeader(): HeadersInit {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
